module.exports = __webpack_public_path__ + "static/media/guter_start.2d5946af.jpg";